<template>
  <div class="Expansionboard">
    <div class="expansion-header">
      <div class="expansion-NavHeader">
        <div class="expansion-NavHeader-left">
          <slot name="headerLeft">
          </slot>
        </div>
        <div class="expansion-NavHeader-Right" @click="toggleExpansion($event)">
          <slot name="headerRight">
          </slot>
        </div>
      </div>
      <span class="expansion-toggle" @click="toggleExpansion($event)">
        <span class="expansion-icon" :class="{ 'expanded': isExpanded }">
          <i class="expansion-icon-svg">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <g clip-path="url(#clip0_1415_1892)">
                <path d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z"
                  fill="black" fill-opacity="0.8" />
              </g>
              <defs>
                <clipPath id="clip0_1415_1892">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </i>
        </span>
      </span>
    </div>
    <div class="expansion-content" :style="{ maxHeight: contentMaxHeight }">
      <div class="content-wrapper" ref="contentWrapper">
        <slot name="content1"></slot>
        <slot name="content2"></slot>
        <slot name="content3"></slot>
        <slot name="content4"></slot>
        <slot name="content5"></slot>
        <slot name="content6"></slot>
        <slot name="content7"></slot>
        <slot name="content8"></slot>
        <slot name="content9"></slot>
        <slot name="content10"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Expansionboard',
  components: {

  },
  props: {
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isExpanded: this.expanded,
      contentMaxHeight: '0',
      observer: null,
      checkHeightInterval: null
    };
  },
  mounted() {
    // 初始化时根据expanded状态设置正确的高度
    if (this.isExpanded) {
      // 先设置为0，再在下一个tick设置为实际高度，确保初始展开也有动画效果
      this.contentMaxHeight = '0';
      this.$nextTick(() => {
        this.animateToHeight(this.$refs.contentWrapper.scrollHeight);
      });
    }

    // 创建观察器监听内容变化
    this.setupObserver();
  },
  beforeDestroy() {
    this.cleanup();
  },
  // Vue 3 中使用 beforeUnmount
  beforeUnmount() {
    this.cleanup();
  },
  computed: {

  },
  watch: {
    expanded(newVal) {
      this.isExpanded = newVal;
      console.log("变化的值", newVal)
      this.toggleContent();
    }
  },
  methods: {
    toggleExpansion(event) {
      console.log("当前点击事件", event)
      event.stopPropagation();
      this.isExpanded = !this.isExpanded;
      this.$emit('update:expanded', this.isExpanded);
      this.$emit('toggle', this.isExpanded);
      this.toggleContent();
    },
    toggleContent() {
      if (this.isExpanded) {
        // 展开动画
        this.contentMaxHeight = '0';
        this.$nextTick(() => {
          this.animateToHeight(this.$refs.contentWrapper.scrollHeight);
        });
      } else {
        // 收起动画 - 确保先获取当前高度再进行动画
        const currentHeight = this.$refs.contentWrapper.scrollHeight;
        this.contentMaxHeight = currentHeight + 'px';
        //console.log('收起动画开始，设置高度为:', this.contentMaxHeight);

        // 使用 setTimeout 确保浏览器渲染完当前高度后再触发动画
        this.$nextTick(() => {
          setTimeout(() => {
            //console.log('触发收起动画，设置高度为0');
            this.contentMaxHeight = '0';
          }, 10);
        });
      }
    },
    animateToHeight(targetHeight) {
      this.contentMaxHeight = targetHeight + 'px';
      //console.log('展开动画，设置高度为:', this.contentMaxHeight);

      // 动画结束后设置为none，确保内容可以正常响应变化
      setTimeout(() => {
        if (this.isExpanded) {
          this.contentMaxHeight = 'none';
          //console.log('动画结束，设置height为none');
        }
      }, 600); // 与CSS过渡时间保持一致
    },
    setupObserver() {
      // 优先使用 ResizeObserver 监听内容尺寸变化
      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(entries => {
          // 当组件处于展开状态且 maxHeight 为 'none' 时，内容变化不需要处理
          // 但如果正在动画过程中，我们需要更新目标高度
          if (this.isExpanded && this.contentMaxHeight !== 'none' && this.contentMaxHeight !== '0') {
            // 如果内容高度发生变化，重新触发动画
            const newHeight = this.$refs.contentWrapper.scrollHeight + 'px';
            if (newHeight !== this.contentMaxHeight) {
              this.contentMaxHeight = newHeight;
            }
          }
        });

        if (this.$refs.contentWrapper) {
          this.observer.observe(this.$refs.contentWrapper);
        }
      }
      // 降级使用 MutationObserver
      else if (window.MutationObserver) {
        this.observer = new MutationObserver(mutations => {
          if (this.isExpanded && this.contentMaxHeight !== 'none' && this.contentMaxHeight !== '0') {
            const newHeight = this.$refs.contentWrapper.scrollHeight + 'px';
            if (newHeight !== this.contentMaxHeight) {
              this.contentMaxHeight = newHeight;
            }
          }
        });

        if (this.$refs.contentWrapper) {
          this.observer.observe(this.$refs.contentWrapper, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
          });
        }
      }
      // 如果都不支持，则定期检查高度变化
      else {
        this.checkHeightInterval = setInterval(() => {
          if (this.isExpanded && this.contentMaxHeight !== 'none' && this.contentMaxHeight !== '0') {
            const newHeight = this.$refs.contentWrapper.scrollHeight + 'px';
            if (newHeight !== this.contentMaxHeight) {
              this.contentMaxHeight = newHeight;
            }
          }
        }, 600);
      }
    },
    cleanup() {
      // 清理观察器
      if (this.observer) {
        if (this.observer instanceof ResizeObserver) {
          this.observer.disconnect();
        } else if (this.observer instanceof MutationObserver) {
          this.observer.disconnect();
        }
        this.observer = null;
      }

      // 清理定时器
      if (this.checkHeightInterval) {
        clearInterval(this.checkHeightInterval);
        this.checkHeightInterval = null;
      }
    }
  }
};
</script>

<style scoped>
.expansion-NavHeader {
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 16px;
}

.Expansionboard {
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-left: 68px;
}

.expansion-header {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
}

.default-header {
  font-weight: bold;
  color: #333;
}
.expansion-icon-svg svg{
  transform: rotate(90deg);
}
.expansion-icon {
  transition: transform 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.expansion-icon.expanded  .expansion-icon-svg svg{
  transform: rotate(270deg) !important;
}

.expansion-content {
  transition: max-height 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
}

.expansion-footer {
  padding: 10px 15px;
  background-color: #fafafa;
  border-top: 1px solid #eee;
}
</style>